module.exports = __webpack_public_path__ + "static/media/close_icon_white_2.614c7e43.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close_icon_white_2.svg
// module id = 1068
// module chunks = 0